export default {
  title: {
    auditLogManagement: '审计日志'
  },
  menu: '审计日志',
  label: {
    companyName: '公司',
    operation: '操作',
    detail: '详情',
    operator: '操作人',
    operateTime: '操作时间'
  },
  placeholder: {
    operation: '选择操作类型'
  },
  logType: {
    USER_MANAGEMENT: '用户管理',
    ROLE_MANAGEMENT: '角色管理'
  },
  operation: {
    CREATE_HR: '创建用户',
    DISABLE_HR: '禁用用户',
    ENABLE_HR: '启用用户',
    EDIT_HR: '编辑用户',
    ASSIGN_ROLE: '为用户添加角色',
    REMOVE_ROLE: '为用户移除角色',
    CREATE_ROLE: '创建角色',
    DELETE_ROLE: '删除角色',
    EDIT_ROLE: '编辑角色'
  }
}
